import React from "react";
import nearby from "../../../patient/pages/DoctorsNearby/doctorsnearby.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Header from "../../../shared/components/Header/Header";
import SearchBar from "../../../shared/components/SearchBar/SearchBar";
import Backicon from "../../../shared/components/Backicon/Backicon";

class DoctorsNearby extends React.Component {
  render() {
    return (
      <div className={nearby.docsNearby}>
        <div className={basestyles.inputWidth}>
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />
          <Header
            name="where is your doctor located?"
            style={{
              margin: "0 auto",
            }}
          />
          <SearchBar />
        </div>
      </div>
    );
  }
}

export default DoctorsNearby;
